import "bootstrap/dist/css/bootstrap.min.css";
import "core-js/stable";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "redux/store";
import "regenerator-runtime/runtime";
import "style/bootsrap-custom.scss";
import "style/index.scss";
import "./utils/language/languageClient";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

// App needs to be imported after styles and store.
import App from "app";

if (process.env.TARGET_ENV == "production" || process.env.TARGET_ENV == "staging") {
    Sentry.init({
        dsn: "https://b1b052c7f265e53e7f807c1775dc4a97@o394619.ingest.sentry.io/4506030809284608",
        integrations: [new BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.2,
        environment: process.env.TARGET_ENV,
    });
}

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);
